var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import { Row, Col, AccordionSet } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
import { FieldRow } from "../../components/FieldRow";
import { AccordionSection } from "../../components/AccordionSection";
import { ExpandCollapseToggle } from "../../components/ExpandCollapseToggle";
import { AuthoritySendErrorBanner } from "../../components/AuthoritySendErrorBanner";
import { LocalAuthorityBanner } from "../../components/LocalAuthorityBanner";
import { PersonTitlesSection } from "../../components/PersonTitlesSection";
var LegalPersonDetail = function (_a) {
    var _b, _c;
    var legalPerson = _a.legalPerson;
    var _d = useState({
        general: true,
        identifiers: true,
        titles: true,
    }), accordionStatus = _d[0], setAccordionStatus = _d[1];
    var _e = useState(true), expandAll = _e[0], setExpandAll = _e[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[section] = !prevState[section], _a)));
        });
    };
    var toggleExpandCollapseAll = function () {
        if (expandAll) {
            setAccordionStatus({
                general: false,
                identifiers: false,
                titles: false,
            });
        }
        else {
            setAccordionStatus({
                general: true,
                identifiers: true,
                titles: true,
            });
        }
        setExpandAll(!expandAll);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.legal-person.detail.pane.title" })),
        React.createElement(LocalAuthorityBanner, { person: legalPerson }),
        React.createElement(AuthoritySendErrorBanner, { person: legalPerson }),
        React.createElement(ExpandCollapseToggle, { expanded: expandAll, onToggle: toggleExpandCollapseAll }),
        React.createElement(AccordionSet, null,
            React.createElement(AccordionSection, { id: "general-info", labelId: "ui-br-agency.legal-person.accordions.label.general", open: accordionStatus.general, onToggle: function () { return toggleAccordion("general"); } },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.legal-person.name.field.label", value: legalPerson.name }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.legal-person.residence.field.label", value: legalPerson.residence }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.legal-person.biographicalNote.field.label", value: legalPerson.biographicalNote }))), (_b = legalPerson.legalAlternativeNames) === null || _b === void 0 ? void 0 :
                _b.map(function (item, idx) { return (React.createElement(Row, { key: idx },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.legal-person.legalAlternativeNames.field.label", value: item.name })))); })),
            React.createElement(AccordionSection, { id: "identifiers", labelId: "ui-br-agency.legal-person.accordions.label.identifiers", open: accordionStatus.identifiers, onToggle: function () { return toggleAccordion("identifiers"); } }, (_c = legalPerson.identifiers) === null || _c === void 0 ? void 0 : _c.map(function (_a) {
                var id = _a.id, type = _a.type, identifier = _a.identifier;
                return (React.createElement(Row, { key: id },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(FieldRow, { labelId: "ui-br-agency.legal-person.identifiers.field.label", value: "".concat(type, ": ").concat(identifier) }))));
            })),
            React.createElement(PersonTitlesSection, { kind: "legal", personId: legalPerson.id, open: accordionStatus.titles, onToggle: function () { return toggleAccordion("titles"); } }))));
};
export default LegalPersonDetail;
